import React from 'react';
import EstoqueTodos  from '../components/Estoque_Todos';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Estoque = () => {
  
  return (
    <div className="content-wrapper">
      <h3>Estoque</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Estoque</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <EstoqueTodos />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <EstoqueTodos />
        </Col>
      </Row>
    </div>
  );
};

export default Estoque;
